<mat-button-toggle-group
  aria-label="Files or menu"
  value="Files"
  hideSingleSelectionIndicator
  #group="matButtonToggleGroup"
  [style.display]="isKIOSK && 'none'"
  >
  <mat-button-toggle
    value="Files"
    [checked]="!isFile"
    (click)="isFile = false; getFiles()"
    >Files</mat-button-toggle
    >
    <mat-button-toggle value="Menu" [checked]="isFile">Menu</mat-button-toggle>
  </mat-button-toggle-group>

  <div style="height: 1rem; width: 200px; overflow: auto"></div>
  @if (isKIOSK) {
    <app-menu></app-menu>
  } @else {
    @switch (group.value) {
      @case ('Files') {
        <as-split
          direction="vertical"
          [gutterSize]="5"
          [style.max-height]="'calc(100% - 4rem - 3px)'"
          >
          <as-split-area [size]="80">
            <div>
              <tree-filter
                [data]="files"
                [isFilter]="false"
                [fileIcon]="true"
                (clickRow)="onFileChoose($event)"
              ></tree-filter>
            </div>
          </as-split-area>
          <as-split-area [size]="20">
            <div style="min-height: 100px; min-width: 200px; height: 100%">
              <pcap-uploader></pcap-uploader>
            </div>
          </as-split-area>
        </as-split>
      }
      @case ('Menu') {
        <app-menu></app-menu>
      }
    }
  }
